import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { CreditReportsDataService } from 'common/services/data-services/admin/reports/credit-reports.service';
import { CreditReportsModel } from 'common/models/page-models/reports/credit-report/credit-report-data-model';
import { CreditReportsGridMetaModel } from 'common/models/page-models/reports/credit-report/credit-report-grid-meta.model';
import { CreditReportsListingModel } from 'common/models/page-models/reports/credit-report/credit-report-grid-model';


@Injectable({
    providedIn: 'root'
})
export class CreditReportsWidgetService extends GridWidgetService<CreditReportsModel, CreditReportsListingModel> {
    constructor(protected override ds: CreditReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new CreditReportsGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: CreditReportsListingModel, metaModel: CreditReportsGridMetaModel, routeData: WidgetModel): Promise<CreditReportsGridMetaModel> {
        return new Promise<CreditReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
                // console.log(metaModel.filterMeta.properties.selectedState.options);
                
            });
            resolve(metaModel);
        });
    }

}